import { Api } from "../../api/adress";
import { IUser } from "./types";

function setLocalStorage(prefix: string, object: any) {
    localStorage.setItem(prefix, JSON.stringify(object));
}

function getLocalStorage(prefix: string) {
    const json = localStorage.getItem(prefix)

    if (!json) {
        return null;
    }

    const object = JSON.parse(json)

    return object ?? null;
}

export function setUserLocalStorage(user: IUser | null) {
    setLocalStorage('leanfarm_user', user);
}

export function setGrupoLocalStorage(grupo: any | null) {
    setLocalStorage('leanfarm_grupo', grupo);
}

export function getUserLocalStorage() {
    return getLocalStorage('leanfarm_user');
}

export function getGrupoLocalStorage() {
    return getLocalStorage('leanfarm_grupo');
}

export async function LoginRequest(usuemail: string, ususenha?: string, usutoken?: string, gruidsuperior?: any) {
    try {
        const request = await Api.post('login', {
            usuemail,
            ususenha,
            usutoken,
            gruidsuperior,
            aplicodigo: 3
        })

        return request;
    } catch (error: any) {
        return error
    }
}

export async function RefreshToken(refresh?: any) {
    try {        
        const request = await Api.post('loginrefresh', {
            refresh,
            aplicodigo: 3
        })

        return request;
    } catch (error: any) {
        return error
    }
}

export async function SigninRequest(usuemail: string, usunome: string) {
    try {
        const request = await Api.post('signin', [{
            usuemail,
            usunome,
            aplicodigo: 3
        }])

        return request;
    } catch (error: any) {
        return error
    }
}

export async function ValidateCodeRequest(usuemail: string, usuvalcodigo: string) {
    try {
        const request = await Api.post('validatecode', {
            usuemail,
            usuvalcodigo,
            aplicodigo: 3
        })

        return request;
    } catch (error: any) {
        return error
    }
}

export async function GetRequest(url: string, token: any, _params?: any) {
    const config = {
        headers: { 'Authorization': `Bearer ${token}` },
        params: _params
    }

    try {
        const response = await Api.get(url, config);
        return response;
    } catch (error: any) {
        return error
    }
}

export async function PostRequest(url: string, token: any, data: any) {
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    }

    try {
        const response = await Api.post(url, data, config);
        return response;
    } catch (error: any) {
        return error
    }
}